// removed by extract-text-webpack-plugin
module.exports = {"pickupDetails":"booking-items__pickupDetails___2saN9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/booking-items/booking-items.scss
// module id = 602
// module chunks = 0